export class CreateScanJobInput {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "resourceId",
            "baseName": "resourceId",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return CreateScanJobInput.attributeTypeMap;
    }
    constructor() {
    }
}
